import React from 'react'
import { Marker } from 'react-leaflet'
import L from 'leaflet'

export const AQIMarker = (props) => {

    const icon = L.divIcon({
        className: "markerHide",
        html: `<div class="aqiMarker"><div class="aqiMarkerValue" style="color: #${props.color}">${Math.round(props.value)}</div></div>`
    });

    return (
        <Marker position={props.location.coordinates} icon={icon}>
        </Marker>
    )
};


// WEBPACK FOOTER //
// ./src/components/Map/MapComponents/AQIMarker.js